import { type FC } from 'react'

import { ClockIcon } from '@dhl-ui/icons'
import { useWeekday } from '@dhl/components'

import { Chip, type ChipProps } from '@dhl-ui/components'
import { type ServicepointOpeningsTime } from './model.js'

type Props = Pick<ChipProps, 'size'> & {
  firstOpeningTime: ServicepointOpeningsTime
}

export const ServicepointOpeningTimesChip: FC<Props> = ({ firstOpeningTime, size }) => {
  const getWeekday = useWeekday()

  const label = `${getWeekday(firstOpeningTime.weekDay)} - ${firstOpeningTime.timeFrom.format('H:mm')} - ${firstOpeningTime.timeTo.format('H:mm')}`

  return <Chip isSquare label={label} startNode={<ClockIcon />} size={size} />
}
